export enum SearchConstants {
  SET_SEARCH_TEXT = 'search/SET_SEARCH_TEXT',
  INITIALIZE_SEARCH = 'search/INITIALIZE_SEARCH',
  SET_FILTERED_OPTIONS = 'search/SET_FILTERED_OPTIONS',
  SET_IS_LOADING = 'search/SET_IS_LOADING',
  CURRENT_OPTIONS = 'search/CURRENT_OPTIONS',
  RESET_STATE = 'search/RESET_STATE',
}
